export default "32b6685b2cf94c6f.png"